import { axios } from '@/utils/request'
const api = {
  create:'/finance/customerStatement',

}
// 获取列表数据
export function getUpdateAmount (parameter) {
  return axios({
    url: api.create + '/enterpriseUpdateAmount',
    method: 'get',
    params: parameter
  })
}
// 客户自费生成对账单
export function getEnterpriseSubmit (parameter) {
  return axios({
    url: api.create + '/enterpriseSubmit',
    method: 'get',
    params: parameter
  })
}

export const sourceExport = api.source + '/export'